'use client';

import { useCallback, useRef } from 'react';
import { useUnit } from 'effector-react';
import { planName, PlanType } from '@lib/billing-plan-name';
import { closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { PopupType } from '@nx-frontend/shared/types';
import { GetOpenFromCallEndPopupProps } from '@nx-frontend/shared/types';

export const getOpenFromCallPopup = ({ openModal, payload }: GetOpenFromCallEndPopupProps) => {
  openModal({
    content: PopupType.FROM_CALL_END,
    showCloseButton: false,
    payload,
  });
};

export function FromCallPopup() {
  const [closeModal] = useUnit([closeModalEvent]);

  const nimTrialWelcomeRef = useRef<HTMLDivElement>(null);

  const onChooseDateClick = useCallback(async () => {
    closeModal();
    window.open('https://get-started.nimbusweb.me/', '_blank');
  }, [closeModal]);

  const showFromCallUpgradePopup = () => (
    <div
      data-cy="from-call-welcome-popup"
      className="w-[1040px] min-w-[1040px] min-h-[493apx] relative nimbus-popup-content text-white"
      ref={nimTrialWelcomeRef}
    >
      <div className="absolute top-[-24px] right-[-1px] cursor-pointer" onClick={() => closeModal}>
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4055 4.28174C14.6983 4.01235 14.6983 3.57559 14.4055 3.3062C14.1126 3.03681 13.6377 3.03681 13.3448 3.3062L8.99539 7.30657L4.6082 3.34126C4.31276 3.07423 3.83791 3.07804 3.54758 3.34977C3.25726 3.6215 3.2614 4.05825 3.55684 4.32528L7.93469 8.28215L3.59479 12.2738C3.3019 12.5432 3.3019 12.9799 3.59479 13.2493C3.88769 13.5187 4.36256 13.5187 4.65545 13.2493L9.00461 9.24919L13.3916 13.2143C13.687 13.4813 14.1618 13.4775 14.4522 13.2058C14.7425 12.934 14.7384 12.4973 14.4429 12.2303L10.0653 8.2736L14.4055 4.28174Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="ml-[48px] mt-[29px] mb-[40px] flex flex-col font-inter">
        <div className="flex">
          <div className="">
            <div className="basis-full w-full !text-[32px] mb-[12px] relative">
              <div className="z-[1] relative font-bold">Ready to Take the Next Step?</div>
            </div>
            <div className="!text-[16px] mb-[16px]" style={{ fontWeight: 400 }}>
              Unlock your full potential and achieve more with <br />
              FuseBase {planName[PlanType.BUSINESS]} features:
            </div>
            <div className="text-base text-justify mb-[30px]" style={{ fontWeight: 400 }}>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                White-labeled Client Portals
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                Granular Permissions
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                AI-powered Copilots
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                Unlimited Client Accounts
              </div>
            </div>
            <div className="mt-[52px] mb-[24px]" style={{ fontWeight: 600 }}>
              Contact us at{' '}
              <a href="mailto:contact@thefusebase.com" className="text-[#96E1DC]">
                contact@thefusebase.com
              </a>{' '}
              or schedule <br />a meeting for a personalized quote and tailored solution
            </div>
            <div className="w-[180px]">
              <button
                className="flex items-center justify-center whitespace-nowrap font-bold select-none h-9 px-8 bg-[#96E1DC] hover:bg-[#96E1DC] active:bg-[#96E1DC] text-[#001216] rounded w-full h-[42px] !text-[16px]"
                onClick={onChooseDateClick}
                style={{ fontWeight: 700 }}
              >
                Choose date
              </button>
            </div>
          </div>
          <div className="absolute bottom-[-60px] right-0">
            <img
              src="/assets/img/from-call-welcome.png"
              width={544}
              height={379}
              className="min-w-[544px] min-h-[379px]"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );

  return showFromCallUpgradePopup();
}
